import { OrderReviewModel } from './import-grid.model';

export class ImportStateModel {
	currentGridPage?: OrderReviewResponse;
	isImportingOrder?: boolean;
	sofDelete?: boolean;
}

export class OrderReviewResponse {
	data?: Array<OrderReviewModel>;
	limit?: number;
	offset?: number;
	totalCount?: number;
}
